module.exports = __webpack_public_path__ + "static/media/about-img.397f2ce6.png";